import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolean'
})
export class BooleanPipe implements PipeTransform {
  transform(value: any, type?: string): any {
    if (type === 'num') {
      return value === '1';
    }
    return Boolean(value);
  }
}
